import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { Util } from '../../../../common/util/util';
import { useActions } from '../../../../hooks/useActions';
import { useUser } from '../../../../hooks/useUser';
import { getPhone } from '../../../../utils/string/getPhone';

import styles from './AuthHeader.module.sass';

const AuthHeaderCall: FC = () => {
  const { setValue } = useFormContext();
  const { setFormType } = useActions();
  const { phone_or_email } = useUser();
  const isEmail = Util.isEmail(phone_or_email);
  if (!phone_or_email) return null;
  return (
    <>
      {isEmail && (
        <div className={styles.block}>
          <p>Код отправлен</p>
          <span className={styles.value}>{phone_or_email}</span>
          <span
            className={styles.changed}
            onClick={() => {
              setValue('email', phone_or_email);
              setFormType('email');
            }}
          >
            Изменить
          </span>
        </div>
      )}

      {!isEmail && (
        <div className={styles.block}>
          <p>Уже звоним на</p>
          <span className={styles.value}>{getPhone(phone_or_email)}</span>
          <span
            className={styles.changed}
            onClick={() => {
              setValue('phone', phone_or_email);
              setFormType('phone');
            }}
          >
            Изменить
          </span>
        </div>
      )}
    </>
  );
};
export default AuthHeaderCall;
